//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'app',
  data () {
    return {
      haveTabber: false, // 是否有底部导航
      closeMenu: true
    }
  },
  watch: {
    $route (to) {
      this.closeMenu = true
      const pathArr = ['/home', /*'/classify',*/ /*'/usercenter',*/ '/login', '/register', '/receive']
      console.log(pathArr.indexOf(to.path))
      if (pathArr.indexOf(to.path) !== -1) {
        this.haveTabber = true
      } else {
        this.haveTabber = false
      }
    }
  },
  methods: {
    // 移动悬浮菜单
    menuMove (e) {
      if (e.touches[0].clientX > 40 && e.touches[0].clientX < window.innerWidth - 5) {
        e.target.style.right = window.innerWidth - e.touches[0].clientX + 'px'
      }
      if (e.touches[0].clientY > 0 && e.touches[0].clientY < window.innerHeight - 40) {
        e.target.style.top = e.touches[0].clientY + 'px'
      }
      e.preventDefault()
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue